<template>
  <div>
    <h3>
      Volunteer - Add - {{ volunteerData.location.name }} on
      {{ volunteerData.location.dateCreated }}
    </h3>
    <br />
    <label>{{ volunteerData.volunteer.name }}</label> has been added. His code
    is:
    <h1>{{ volunteerData.volunteer.pinCode }}</h1>
    <div>
      <router-link
        tag="button"
        :to="{ name: 'volunteers', params: { id: $route.params.locId } }"
        >Cancel</router-link
      >
      <router-link
        tag="button"
        :to="{ name: 'volunteers', params: { id: $route.params.locId } }"
        >Finished</router-link
      >
      <router-link
        tag="button"
        :to="{ name: 'addVolunteer', params: { id: $route.params.locId } }"
        >Add Another Volunteer</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "volunteerCode",
  data: () => ({
    volunteerData: {
      location: {},
      volunteer: {}
    }
  }),
  methods: {
    loadVolunteerData(volId, locId) {
      this.axios
        .get(
          process.env.VUE_APP_API_URL + "surveys/search/" + volId + "/" + locId
        )
        .then(response => (this.volunteerData = response.data))
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.loadVolunteerData(this.$route.params.volId, this.$route.params.locId);
  }
};
</script>
